export const languages = ["en", "uk", "ar"] as const;

export type Language = (typeof languages)[number];

export function isRtlLanguage(lang: string): boolean {
  return lang === "ar";
}
